import {useContext, useEffect, useMemo, useState} from "react";
import {SessionUserContext} from "../context/UserContext";
import {API_URL, findPriceInRange, formatPrice, getLawnLotSize} from "../utils";
import GoogleMapsAreaSelector from "./GoogleMapsAreaSelector";


const NO_OF_FULL_SERVICES = 3

const CURRENT_PROGRAM_PRODUCT_ID = 'prod_QOktPz7pmvxbXE'

const core_Products = [

    // {
    //     "id": "bug-and-grub",
    //     "object": "product",
    //     "active": true,
    //     "attributes": [],
    //     "created": 1709817615,
    //     "default_price": null,
    //     "description": null,
    //     "features": [],
    //     "images": [],
    //     "livemode": false,
    //     "metadata": [],
    //     "name": "bug and grub",
    //     "package_dimensions": null,
    //     "shippable": null,
    //     "statement_descriptor": null,
    //     "tax_code": null,
    //     "type": "service",
    //     "unit_label": null,
    //     "updated": 1709817615,
    //     "url": null
    // },

    // {
    //     "id": "core-aeration",
    //     "object": "product",
    //     "active": true,
    //     "attributes": [],
    //     "created": 1709817614,
    //     "default_price": null,
    //     "description": null,
    //     "features": [],
    //     "images": [],
    //     "livemode": false,
    //     "metadata": [],
    //     "name": "Core Aeration",
    //     "package_dimensions": null,
    //     "shippable": null,
    //     "statement_descriptor": null,
    //     "tax_code": null,
    //     "type": "service",
    //     "unit_label": null,
    //     "updated": 1709817614,
    //     "url": null
    // },

    // {
    //     "id": "sixserviceprogram",
    //     "object": "product",
    //     "active": true,
    //     "attributes": [],
    //     "created": 1709817614,
    //     "default_price": null,
    //     "description": null,
    //     "features": [],
    //     "images": [],
    //     "livemode": false,
    //     "metadata": [],
    //     "name": "Pre-Pay for full program",
    //     "meta": "Save 5% when you prepay for the full program",
    //     "package_dimensions": null,
    //     "shippable": null,
    //     "statement_descriptor": null,
    //     "tax_code": null,
    //     "type": "service",
    //     "unit_label": null,
    //     "updated": 1709817614,
    //     "url": null,
    //
    // },

    {
        "id": CURRENT_PROGRAM_PRODUCT_ID,
        "object": "product",
        "active": true,
        "attributes": [],
        "created": 1709817614,
        "default_price": null,
        "description": null,
        "features": [],
        "images": [],
        "livemode": false,
        "metadata": [],
        "name": "Pre-Pay for full program",
        "meta": "Save 5% when you prepay for the full program",
        "package_dimensions": null,
        "shippable": null,
        "statement_descriptor": null,
        "tax_code": null,
        "type": "service",
        "unit_label": null,
        "updated": 1709817614,
        "url": null
    },
    {
        "id": "50-off-1st-svc",
        "object": "product",
        "active": true,
        "attributes": [],
        "created": 1709817613,
        "default_price": null,
        "description": null,
        "features": [],
        "images": [],
        "livemode": false,
        "metadata": [],
        "name": "Pay As You Go",
        "package_dimensions": null,
        "shippable": null,
        "statement_descriptor": null,
        "tax_code": null,
        "type": "service",
        "unit_label": null,
        "updated": 1709819082,
        "url": null
    }
]

const addOnProducts = [

    {
        "id": "core-aeration-10-pre-pay",
        "object": "product",
        "active": true,
        "attributes": [],
        "created": 1709817614,
        "default_price": null,
        "description": null,
        "features": [],
        "images": [],
        "livemode": false,
        "metadata": [],
        "name": "Core Aeration 10% pre-pay",
        "package_dimensions": null,
        "shippable": null,
        "statement_descriptor": null,
        "tax_code": null,
        "type": "service",
        "unit_label": null,
        "updated": 1709817614,
        "url": null
    },
    {
        "id": "1-2-price-bug-and-grub-with-lawn-program",
        "object": "product",
        "active": true,
        "attributes": [],
        "created": 1709817615,
        "default_price": null,
        "description": null,
        "features": [],
        "images": [],
        "livemode": false,
        "metadata": [],
        "name": "1\/2 price bug and grub with lawn program",
        "package_dimensions": null,
        "shippable": null,
        "statement_descriptor": null,
        "tax_code": null,
        "type": "service",
        "unit_label": null,
        "updated": 1709817615,
        "url": null
    },
]

const PropertyData = () => {

    const userContext = useContext(SessionUserContext)

    const [sf, setSf] = useState<number>(0)
    const [userLotSf, setUserLotSf] = useState<number>(0)
    const [selectingLawnSize, setSelectingLawnSize] = useState<boolean>(false)
    const [loadingData, setLoadingData] = useState<boolean>(false)

    const [products, setProducts] = useState<any>()
    const [filteredProducts, setFilteredProducts] = useState<any>()
    const [showProducts, setShowProducts] = useState<boolean>(false)

    const [addOns, setAddOns] = useState<any>()
    const [filteredAddOns, setFilteredAddOns] = useState<any>()


    const [selectedService, setSelectedService] = useState<any>()
    const [selectedAddOn, setSelectedAddOn] = useState<any[]>([])


    const [loading, setLoading] = useState(false)


    const firstServiceDiscountedPrice = useMemo(() => {
        if (!filteredProducts) {
            return 0
        }
        const prFound = filteredProducts.find((product: any) => {
            return product.id === '50-off-1st-svc'
        })
        if (prFound) {
            return prFound.price?.unit_amount
        }
        return 0
    }, [filteredProducts])

    const perServicePrice = useMemo(() => {
        if (!filteredProducts) {
            return 0
        }
        const prFound = filteredProducts.find((product: any) => {
            return product.id === '50-off-1st-svc'
        })
        if (prFound) {
            return prFound.price?.unit_amount * 2
        }
        return 0
    }, [filteredProducts])

    const nonDiscountedFullProgramPrice = useMemo(() => {
        return (perServicePrice * NO_OF_FULL_SERVICES) + firstServiceDiscountedPrice

    }, [firstServiceDiscountedPrice, perServicePrice])

    const lotSize = useMemo(() => {
        if (userLotSf > 0) {
            return userLotSf
        }
        return getLawnLotSize(sf)
    }, [sf, userLotSf])


    useEffect(() => {
        if (sf > 15000) {
            setShowProducts(false)
            setSelectingLawnSize(true)
        } else {
            setSelectingLawnSize(false)
        }
    }, [sf, setSelectingLawnSize]);

    const getPrices = async () => {
        const square_feet = findPriceInRange(lotSize)

        const options: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                ...square_feet,
                products: core_Products.map(pr => pr.id),
            })
        };

        await fetch(API_URL + '/getProducts', options)
            .then(response => response.json())
            .then(response => {
                setProducts(response)
                return response
            })
            .catch(err => console.error(err));
    }


    const getAddonPrices = async () => {
        const square_feet = findPriceInRange(lotSize)

        const options: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                ...square_feet,
                products: addOnProducts.map(pr => pr.id),
            })
        };

        await fetch(API_URL + '/getProducts', options)
            .then(response => response.json())
            .then(response => {

                setAddOns(response)
                return response
            })
            .catch(err => console.error(err));
    }


    const onConfirmSquareFeet = (specifiedLotSize: number | null = null) => {

        if (lotSize > 15000 && !userLotSf) {
            return
        }

        const square_feet = findPriceInRange(specifiedLotSize ?? lotSize)


        const newProducts = products?.map((product: any) => {
            return {
                ...product,
                price: (product.prices as any[]).find(pr => pr.metadata.square_feet === square_feet?.square_feet)
            }
        })


        const newAddOns = addOns?.map((product: any) => {
            return {
                ...product,
                price: (product.prices as any[]).find(pr => pr.metadata.square_feet === square_feet?.square_feet)
            }
        })

        setFilteredProducts(newProducts)
        setFilteredAddOns(newAddOns)
        setShowProducts(true)
    }

    useEffect(() => {


        Promise.all([getPrices(), getAddonPrices()])
            .then(() => {
                setSf(userContext.propertySize || 0)
                onConfirmSquareFeet()
            })
    }, []);

    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.has('session')) {
            const session_id = url.searchParams.get('session');

            if (session_id) {
                const storedData = window.localStorage.getItem(session_id)

                if (storedData) {
                    setLoadingData(true)
                    Promise
                        .all([getPrices(), getAddonPrices()])
                        .then(() => {
                            const data = JSON.parse(storedData)
                            setSelectedService(data.selectedService)
                            setSelectedAddOn(data.selectedAddOn)
                            if (data.polygons) {
                                setSelectingLawnSize(true)
                            }
                        }).finally(() => {
                        setLoadingData(false)
                    })


                }
            }
        }
    }, []);


    const checkout = async () => {
        setLoading(true)
        const options: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                products: [selectedService, ...selectedAddOn],
                customer: userContext.user,
                paths: userContext.polygons
            })
        };

        await fetch(API_URL + '/checkout', options)
            .then(response => response.json())
            .then(response => {
                if (response.id) {
                    window.localStorage.setItem(response.id, JSON.stringify({
                        selectedService,
                        selectedAddOn,
                        location: userContext.location,
                        user: userContext.user,
                        polygons: userContext.polygons
                    }))
                }
                if (response.url) {
                    window.location.href = response.url
                }
            })
            .catch(err => {
                setLoading(false)
                console.error(err)
            });
    }

    const totalPrice = useMemo(() => {
        const prices = [...selectedAddOn, selectedService].map((product: any) => {
            return product?.price?.unit_amount || 0
        })
        return prices.reduce((a, b) => a + b, 0)
    }, [selectedAddOn, selectedService])

    const getFullProgramPrice = () => {

    }

    return (
        <section>
            <div className="uk-container">
                <div className="uk-panel">
                    <div className={"uk-flex uk-flex-middle"}>
                        <button onClick={() => {
                            userContext.setUser(null)
                        }} className="uk-icon-button uk-margin-small-right" data-uk-icon="arrow-left"></button>
                        <p className={"uk-text-lead"}>
                            Lawn service for <b className={"uk-text-primary"}>{userContext.user?.address?.line1}</b>
                        </p>
                    </div>
                    <div className={"step-block"}>
                        <span>Step 1:</span> Enter your property size
                    </div>
                    <h2 className={"uk-margin-remove-top"}>
                        What is your lot size?
                    </h2>
                    <p>
                        We need to know the size of your property to give you an accurate price. Please enter an
                        estimate lot size for your property
                    </p>
                    <div className="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                        <div>
                            <input type="tel"
                                   autoFocus
                                   onKeyDown={(e) => {
                                       if (e.key === 'Enter') {
                                           onConfirmSquareFeet()
                                       }
                                   }}
                                   defaultValue={sf > 0 ? sf : ''}
                                   disabled={userLotSf > 0}
                                   onInput={(ev) => {
                                       const inputString = ev.currentTarget.value
                                       // Regular expression to match decimal or whole numbers
                                       const regex = /(\d+(\.\d+)?)/g;
                                       // Use match to find all matches of the regex in the input string
                                       const matches = inputString.match(regex);
                                       // Filter out null values and convert strings to numbers
                                       const result = matches ? matches.map(match => parseFloat(match)).join('') : '';
                                       setSf(result ? parseFloat(result) : 0)
                                       ev.currentTarget.value = result
                                   }} autoComplete={"off"} name={"propertySize"} className={"uk-input"}
                                   placeholder={"Property size"}/>
                        </div>
                        <div>
                            sq. ft.
                        </div>
                        <div>
                            <button onClick={() => onConfirmSquareFeet()} className="uk-button uk-button-secondary">
                                Confirm
                            </button>
                        </div>
                    </div>
                    {sf > 0 && !selectingLawnSize && <div className={"uk-margin-small-top"}>
                        <p className={"uk-text-lead"}><span uk-icon={"arrow-right"}></span> Your estimated lawn size
                            is <span className={"uk-text-primary"}>{Math.ceil(lotSize)} sq. ft.</span> <a
                                className={"uk-margin-small-left uk-button-text"} onClick={() => {
                                setShowProducts(false)
                                setSelectingLawnSize(true)
                            }}>Select Area Myself</a></p>

                    </div>}
                </div>

                {selectingLawnSize && <GoogleMapsAreaSelector onConfirmAreaSelection={area => {

                    setUserLotSf(area)

                    if (area === 0) {
                        setShowProducts(false)
                        return
                    }

                    onConfirmSquareFeet(area)
                    // @ts-ignore
                    UIkit.scroll(document.querySelector('#service-start'), {
                        offset: 300
                    }).scrollTo(document.querySelector('#service-start'))

                }}/>}
                <div id={"service-start"}></div>
                {userLotSf > 0 && <div className={"uk-margin-top"}>
                    <h4 id={"lot-size"}>
                        Your lawn size is <b className={"uk-text-primary"}>{userLotSf} sq. ft.</b>
                    </h4>
                </div>}
                {showProducts && filteredProducts && <div className="uk-panel uk-margin-top">
                    <hr/>
                    <div className={"step-block"}>
                        <span>Step {selectingLawnSize ? 3 : 2}:</span> Select A Service Package
                    </div>
                    <h2 className={"uk-margin-remove-top"}>
                        Select A Service Package
                    </h2>
                    <h3>
                        Proganix Program
                    </h3>
                    <p>Our 6 service program features probiotics on each service, which aids in bringing life to the
                        soil. It is designed to deliver 100% of what the lawn and soil needs. These microorganisms
                        reinforce beneficial fungi and bacteria, converting to a nutrient the plant can eat! With this
                        product and development, we believe what you receive in 5 or 6 services from us well exceeds
                        what you receive in 7 or more services from a competitor.
                        <br/>

                        <h4 className={"uk-margin-small-bottom"}>4 SERVICE PROGANIX PROGRAM</h4>



                        <b>{formatPrice(firstServiceDiscountedPrice)} (50% Discount)…</b>

                        Stress Reliever (early Summer)<br/>Bio-Nutritional Stress Reliever
                        Fertilizer, summer weed control, pH Adjustment &amp; Soil Conditioner
                        <hr className={"uk-margin-small"}/>
                        <b>{formatPrice(perServicePrice)}…</b>

                        Recovery (mid
                        Summer)<br/>Bio-Nutritional Recovery Fertilizer, Summer Weed Control, pH Adjustment &amp; Soil
                        Conditioner
                        <hr className={"uk-margin-small"}/>
                        <b>{formatPrice(perServicePrice)}…</b>

                        Deep Green (late Summer)<br/>98% Natural, Spot Spray Summer Weed Control
                        Micronutrients, pH Adjustment, &amp; Soil Conditioner
                        <hr className={"uk-margin-small"}/>
                        <b>{formatPrice(perServicePrice)}…</b>

                        Winterizer (Fall)<br/>Bio-Nutritional
                        Fall Fertilizer, Spot Spray Weed Control, &amp; Soil Conditioner
                    </p>
                    <div></div>
                    <div className="uk-grid uk-grid-small uk-child-width-expand@m" data-uk-grid>
                        {filteredProducts.map((product: any) => (
                            <div key={product.id}>
                                <a onClick={() => setSelectedService(product)}
                                   className={(selectedService?.id && selectedService.id === product.id) ? 'uk-card uk-card-default uk-card-body uk-link-reset selected-card product-card' : 'uk-card uk-card-default uk-card-body uk-link-reset product-card'}>
                                    <h3>
                                        {product.name}
                                    </h3>
                                    <p>
                                        {product.description}
                                    </p>
                                    <p className={"uk-text-lead uk-text-primary"}>
                                        <span
                                            className={"uk-margin-small-right uk-text-muted"}>{product.id === CURRENT_PROGRAM_PRODUCT_ID ?
                                            <s>{formatPrice(nonDiscountedFullProgramPrice)}</s> :
                                            <s>{formatPrice(perServicePrice)}</s>}</span>
                                        <span>{product.price ? `${formatPrice(product.price.unit_amount)}` : 'Price not available'}</span>
                                    </p>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>}

                {showProducts && selectedService && filteredAddOns && <div className="uk-panel uk-margin-top">
                    <hr/>
                    <div className={"step-block"}>
                        <span>Step {selectingLawnSize ? 4 : 3}:</span> Select An Ad-On (OPTIONAL)
                    </div>
                    <h2 className={"uk-margin-remove-top"}>
                        Discounted Add Ons with your purchase
                    </h2>
                    <p>
                        Select a discounted add on with the purchase of a service package.
                    </p>
                    <div className="uk-grid uk-grid-small uk-child-width-expand@m" data-uk-height-match={".uk-card"}
                         data-uk-grid>
                        {filteredAddOns.map((product: any) => (
                            <div key={product.id}>
                                <a onClick={() => {

                                    const foundIndex = selectedAddOn.findIndex(aa => aa.id === product.id)
                                    if (foundIndex > -1) {
                                        setSelectedAddOn(addOns => addOns.filter(aa => aa.id !== product.id))
                                        return
                                    }

                                    setSelectedAddOn(addOns => [...addOns, product])
                                }}
                                   className={(selectedAddOn.find(aa => aa.id === product.id)) ? 'uk-card uk-card-default uk-card-body uk-link-reset selected-card product-card' : 'uk-card uk-card-default uk-card-body uk-link-reset product-card'}>
                                    <h3 className={"uk-h4"}>
                                        {product.name}
                                    </h3>
                                    <p>
                                        {product.description}
                                    </p>
                                    <p className={"uk-text-lead uk-text-primary"}>
                                        {product.price ? `${formatPrice(product.price.unit_amount)}` : 'Price not available'}
                                    </p>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>}

                {selectedService && <div className={"uk-width-1-1 uk-margin-top"}>
                    <button onClick={() => checkout()} className={"uk-button uk-button-secondary uk-button-large"}>
                        {loading ? <div data-uk-spinner></div> : 'Checkout'}
                    </button>
                </div>}
            </div>
            {totalPrice > 0 && <div className={"uk-position-fixed"} style={{
                bottom: '5%',
                right: '5%',
            }}>
                <div
                    className={"uk-card uk-card-default uk-background-primary uk-card-body uk-card-small uk-box-shadow-large uk-preserve-color"}>
                    <div className={"uk-light"}><b>Total Price: </b>
                        {formatPrice(totalPrice)}
                    </div>
                    <div className={"uk-card-media"}>
                        <button onClick={() => checkout()}
                                className={"uk-button uk-width-1-1 uk-button-small uk-button-secondary uk-margin-small-top"}>
                            {loading ? <div data-uk-spinner></div> : 'Checkout'}
                        </button>
                    </div>
                </div>
            </div>}

            {loadingData && <div className="uk-overlay-default uk-position-cover">
                <div className="uk-position-center" style={{position: 'fixed', background: 'rgb(0 131 72 / 85%)'}}>
                    <span data-uk-spinner></span>
                </div>
            </div>}
        </section>
    )
}
export default PropertyData;